import Cookies from 'js-cookie';
import { Language, CookieNames } from 'config/constants';

export const BASE_URL = '/new-stage/api/v1';
export const PROJECT_TOKEN = '687a8689-eef7-4fc0-a12f-53ea6c38bf13';
export const X_DEVICE_BY = 'web/1.0.0';
export const CONTENT_TYPE = 'application/json';

export enum Entity {
    auth = 'auth',
    profile = 'profile',
    text = 'text',
    likes = 'likes',
    search = 'search',
    profiles = 'profiles',
    feedback = 'feedback',
    chat = 'profile-chats',
    message = 'message',
    config = 'config',
    tests = 'tests',
}

interface IDefaultHeaders {
    'Content-Type'?: string
    'Accept'?: string
    'Project-Token': string
    'x-device-by': string
}

interface IDynamicHeaders {
    Authorization: string
    Language: string
}

export const getDefaultHeaders = (isFormData?:boolean):IDefaultHeaders => {
    const headers:IDefaultHeaders = {
        [CookieNames.Accept]: CONTENT_TYPE,
        [CookieNames.ProjectToken]: PROJECT_TOKEN,
        [CookieNames.Device]: X_DEVICE_BY,
    };

    if (!isFormData) {
        headers[CookieNames.ContentType] = CONTENT_TYPE;
    }

    return headers;
};

export const getDynamicHeaders = ():IDynamicHeaders => {
    const authorization = Cookies.get(CookieNames.AuthToken) || '';
    const language = Cookies.get(CookieNames.Language) || Language.Ru;

    return {
        Authorization: authorization,
        Language: language,
    };
};
